import React from 'react'

import { getCurrentlyOffered, searchCurrentlyOffered } from '@/services/Courses'

import DataTableProvider from './DataTable'

const CourseContext = React.createContext([[], () => {}])

const CourseProvider = ({ children }) =>
  DataTableProvider({
    context: CourseContext,
    getAll: getCurrentlyOffered,
    search: searchCurrentlyOffered,
    processResponse: ({ count, courses }) => ({ count, data: courses }),
    children,
  })

export { CourseContext, CourseProvider }
